
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace/[[...slug]]",
      function () {
        return require("private-next-pages/workspace/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace/[[...slug]]"])
      });
    }
  